import { render, staticRenderFns } from "./comfirmInfo.vue?vue&type=template&id=6ec37148&scoped=true"
import script from "./comfirmInfo.vue?vue&type=script&lang=js"
export * from "./comfirmInfo.vue?vue&type=script&lang=js"
import style0 from "./comfirmInfo.vue?vue&type=style&index=0&id=6ec37148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec37148",
  null
  
)

export default component.exports